// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".billing-summary[data-v-54b36f6a] {\n  border: 1px solid #e8eef1;\n  color: #003545;\n}\n.billing-summary > .col[data-v-54b36f6a]:not(:last-of-type) {\n  border-right: 1px solid #e8eef1;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
